import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';
import { getRemakesCheckedSummary } from 'services/productionOverviewService';
import { getRightFirstTimePercent, mapRemakeGroups } from './qualitySummaryHelpers';
import QualitySummaryCard from './QualitySummaryCard';

export default function QualityRemakesSummary({ date }) {
  const [totalRemake, setTotalRemake] = useState(null);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getRemakesCheckedSummary(date)
      .then(result => {
        if (cancelled) return;
        const data = result?.data?.data || result?.data || {};
        setTotalRemake(typeof data.totalRemake === 'number' ? data.totalRemake : null);
        setGroups(Array.isArray(data.groups) ? data.groups : []);
      })
      .catch(err => {
        if (!cancelled) console.error('Error fetching remakes checked summary', err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [date]);

  const cards = useMemo(
    () =>
      mapRemakeGroups(groups).map(item => ({
        ...item,
        rftPercent: getRightFirstTimePercent(item.totalChecked, item.totalRejected)
      })),
    [groups]
  );

  return (
    <section className="quality-summary-section" style={{ marginTop: 20 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 10 }}>
        <h4 className="quality-summary-section-title" style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>
          Remakes Checked Summary
        </h4>
        {totalRemake != null && (
          <span className="quality-summary-status" style={{ fontSize: 12 }}>
            Total remake jobs today: <strong>{totalRemake}</strong>
          </span>
        )}
      </div>

      {loading ? (
        <div className="text-center py-3">
          <Spinner variant="primary" animation="border" role="status" />
        </div>
      ) : cards.length > 0 ? (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12 }}>
          {cards.map(c => (
            <QualitySummaryCard
              key={c.key}
              label={c.label}
              rftPercent={c.rftPercent}
              stats={[
                { label: 'Total Remake', value: c.totalRemake },
                { label: 'Checked', value: c.totalChecked },
                { label: 'Rejected', value: c.totalRejected }
              ]}
            />
          ))}
        </div>
      ) : (
        <div className="quality-summary-status" style={{ fontSize: 13 }}>
          No remakes checked data for this date.
        </div>
      )}
    </section>
  );
}

QualityRemakesSummary.propTypes = {
  date: PropTypes.string.isRequired
};
